import { useRootStore } from "store";
import InventoryInternalUser from "./InventoryInternalUser";
import InventoryExternalUser from "./InventoryExternalUser";

import "./Inventory.scss";

export default function Inventory() {
  const { user } = useRootStore((state) => state);

  const isInternal = user.userInfo?.type === "Internal";

  return (
    <div className="inventory box">
      <h1>Inventering</h1>
      <hr className="header-border" />
      {isInternal ? <InventoryInternalUser /> : <InventoryExternalUser />}
    </div>
  );
}
